<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                    class="mt-3"
                    :data="tabData">
                    <template slot="gofixTab:right">
                        <gofix-button
                            @click="saveData"
                            label="SAVE"
                            :loading="loading"
                            :disabled="$disabledCreateOrUpdate(this.item, $accessModule.maintenance_standard)"></gofix-button>
                    </template>
                    <template slot="gofixTab:basic-info">
                        <b-form>
                            <gofix-card classContent="mb-0 mt-4">
                                <b-row>
                                    <b-col md="2">
                                        <gofix-form-input label="PM Code" v-model="item.sor_code" required></gofix-form-input>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input label="Abbreviation" v-model="item.abbreviation"></gofix-form-input>
                                    </b-col>
                                </b-row>
                            </gofix-card>
                            <gofix-card classContent="mt-4 mb-0">
                                <b-row>
                                    <b-col md="4">
                                        <gofix-form-tree
                                            label="Service Category"
                                            :default-expand-level="1"
                                            :multiple="false"
                                            :options="dataService"
                                            :load-options="loadOptionsService"
                                            :normalizer="normalizerService"
                                            search-nested
                                            valueFormat="object"
                                            v-model="item.service_category"
                                            placeholder="Select"
                                            ref="input">
                                        </gofix-form-tree>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-tree
                                            label="Equipment Group"
                                            :default-expand-level="1"
                                            :multiple="false"
                                            :options="dataEquipment"
                                            :load-options="loadOptionsEquiment"
                                            :normalizer="normalizerEquipment"
                                            search-nested
                                            valueFormat="object"
                                            v-model="item.equipment_type"
                                            placeholder="Select"
                                            ref="equipmentTree">
                                        </gofix-form-tree>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="4">
                                        <div class="d-flex maintCreateFrequency align-items-center">
                                            <gofix-form-dropdown
                                                label="Frequency"
                                                vLabel="recurring_mode"
                                                :clearable="false"
                                                :filterable="false"
                                                :required="true"
                                                :reduce="option => option.id"
                                                v-model="item.sor_recurring_mode_id"
                                                :options="dataRecurring">
                                            </gofix-form-dropdown>
                                            <gofix-button v-if="$checkRole($accessModule.maintenance_standard, 'create')" class="ml-3" label="Create Frequency" @click="modals.frequency.open = true" noBorder fontNormal small></gofix-button>
                                        </div>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-dropdown
                                            label="Checklist template"
                                            vLabel="name_checklist_templates"
                                            :clearable="false"
                                            :filterable="false"
                                            :required="true"
                                            :reduce="option => option.id"
                                            v-model="item.checklist_template_id"
                                            :options="dataChecklist">
                                        </gofix-form-dropdown>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="4">
                                        <gofix-form-input label="Standard Reference" v-model="item.standard_reference"></gofix-form-input>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-input label="Remarks" v-model="item.remarks"></gofix-form-input>
                                    </b-col>
                                </b-row>
                            </gofix-card>
                        </b-form>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <b-modal 
            no-close-on-backdrop
            id="modal-Create"
            title="Create Frequency"
            hide-footer 
            centered
            v-model="modals.frequency.open">
            <b-form class="pb-20">
                <b-row>
                    <b-col md="6">
                        <gofix-form-input-number
                            label="Number"
                            :include-thousands-separator="false"
                            v-model="modals.frequency.data.number"
                            :allowDecimal="false">
                        </gofix-form-input-number>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-dropdown
                            label="Unit"
                            vLabel="reference_value_text"
                            :clearable="false"
                            :filterable="false"
                            :required="true"
                            :reduce="option => option.reference_value_text"
                            v-model="modals.frequency.data.type_date"
                            :options="frequencyUnits">
                        </gofix-form-dropdown>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="addFrequency" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    const simulateAsyncOperation = fn => {
        setTimeout(fn, 500)
    }
    export default {
        name: 'maintenance-standard-info',
        data () {
            return {
                tabData:[
                    {
                        key: "basic-info",
                        title: "Basic Info",
                        active: true
                    },
                ],
                item: {
                    sor_code:null,
                    sor_group_id:null,
                    service_category_id:null,
                    service_category:null,
                    equipment_type:null,
                    equipment_group_id:null,
                    is_maintenance:true,
                    tolerance_period:null,
                    sor_recurring_mode_id:null,
                    checklist_template_id:null,
                    is_master: true,
                    contract_term_id: null,
                    standard_reference: null,
                    remarks: null,
                    abbreviation: null,
                    unit_price: null,
                },
                loading: false,
                dataService : [],
                dataEquipment : [],
                dataChecklist : [],
                dataRecurring : [],
                validate: false,
                modals:{
                    frequency : {
                        open: false,
                        loading: false,
                        data : {
                            number: '',
                            type_date: 'D',
                        }
                    }
                },
                frequencyUnits:[]
            }
        },
        async created() {
            if(this.$route.params && parseInt(this.$route.params.maintenance_id)){
                this.$store.dispatch("v2SorController/getItem",this.$route.params.maintenance_id)
                    .then(response => {
                        this.item = response.data.data;

                        if(this.item.equipment_group_id) {
                            this.item.equipment_type = response.data.data.equipment_structure_type;
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            }

            this.getDataEquipment(0,'all',true);
            this.getDataService(0,'all',true);
            this.getDataRecurring();
            this.getDataChecklist();
            this.getFrequencyUnit();
        },
        methods:{
            /*---- Save Data -------*/
            saveData(){
                this.validate = true;
                if(!this.item.sor_code
                    || !this.item.service_category
                    || !this.item.sor_recurring_mode_id
                    || !this.item.checklist_template_id
                ) {
                    this.$alertNotification("Please enter in the required fields", "danger");
                    return false;
                }

                this.item.service_category_id = this.item.service_category ? this.item.service_category.id : null;
                this.item.equipment_group_id = this.item.equipment_type ? this.item.equipment_type.id : null;
                this.item.is_master = true;
                this.item.is_maintenance = true;
                this.loading = true;
                this.$store.dispatch("v2SorController/createItem",this.item).then(async response => {
                    this.loading = false;
                    let keyMessage= 'editing';
                    if(!this.item.id) {
                        keyMessage = 'adding';
                        await this.$router.push(`${this.$route.matched[this.$route.matched.length - 1].parent.path}/${response.id}`);
                    }

                    await this.$alertNotification(this.$notificationV2(keyMessage, 'maintenance_standard'));
                }).catch(err => {
                    this.loading = false;
                    this.$alertNotification(err.response.data.error.message.error, "danger");
                });
            },
            addFrequency() {
                if(this.modals.frequency.loading) return;
                this.modals.frequency.loading = true;
                this.$store.dispatch('SorRecurringModesController/createSorRecurringModes',this.modals.frequency.data)
                    .then(result => {
                        this.item.sor_recurring_mode_id = result.data.data.id;
                        this.modals.frequency.open = false;
                        this.modals.frequency.loading = false;
                        this.getDataRecurring();
                        return this.$alertNotification("Create frequency successfully!");
                    })
                    .catch(error => {
                        this.modals.frequency.loading = false;
                        if(error.response) {
                            if(error.response.data.error.message.number)
                                return this.$alertNotification(error.response.data.error.message.number[0], "danger");
                            if(error.response.data.error.message.recurring_mode)
                                return this.$alertNotification("Frequency already exist", "danger");
                            return this.$alertNotification("Error", "danger");
                        }
                    })
            },
            /*--------------------------------------------*/

            /*---- Get Data -------*/
            async getDataEquipment(parent_id,node_type,set = false){
                let dataE = [];
                await global.axios(`api/master/tree-equiqment-structures/${parent_id}`, {
                    method: "GET",
                    headers: { Accept: "application/json", },
                    params: {
                        node_type: node_type
                    },
                })
                    .then(response => {
                        dataE = response.data.data;
                    }).catch(error => {
                        console.log(error);
                    });
                if(set){
                    this.dataEquipment = dataE;
                }else{
                    return dataE
                }
            },
            async getDataService(parent_id,node_type,set = false){
                let data = [];
                await global.axios(`api/master/tree-service-categories/${parent_id}`, {
                    method: "GET",
                    headers: { Accept: "application/json", },
                    params: {
                        node_type: node_type
                    },
                })
                    .then(response => {
                        data = response.data.data;
                    }).catch(error => {
                        console.log(error);
                    });
                if(set){
                    this.dataService = data;
                }else{
                    return data
                }
            },
            getDataRecurring(){
                this.$store.dispatch('SorRecurringModesController/getListSorRecurringModes')
                    .then(response => {
                        this.dataRecurring =  response.data.data
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            getDataChecklist(){
                this.$store.dispatch( 'v2CheckListTemplateController/searchTemplate', [
                    1000, 1, {is_master: true}
                ])
                    .then(response => {
                        this.dataChecklist = response.data.data.items
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            getFrequencyUnit(){
                let filter = {reference_type: "Frequency Unit"};
                let params = {
                    filter: filter,
                    limit: -1,
                    sortColumn: "id",
                    sortDirection: "asc",
                };
                this.$store.dispatch(`ReferenceController/getItems`, params)
                    .then(response => {
                        this.frequencyUnits = response.items;
                    })
            },
            /*---------------------------*/

            /*-----------------------------------*/
            loadOptionsService({ action, parentNode, callback,instanceId  }){
                if (action === "LOAD_CHILDREN_OPTIONS" ) {
                    simulateAsyncOperation(async () => {
                        parentNode.children = await this.getDataService(parentNode.data.id,'all');
                        callback()
                    })
                }
            },
            normalizerService(node) {
                if(node.data && !node.data.isBatch){
                    return {
                        children : undefined,
                        label: node.name
                    }
                }
                return {
                    label: node.name
                }
            },
            loadOptionsEquiment({ action, parentNode, callback }) {
                if (action === "LOAD_CHILDREN_OPTIONS" ) {
                    simulateAsyncOperation(async () => {
                        parentNode.children = await this.getDataEquipment(parentNode.data.id,'all');
                        callback()
                    })
                }
            },
            normalizerEquipment(node) {
                if(node.data && node.data.isBatch) {
                    return {
                        id: node.data.id,
                        label: node.data.name,
                        children: node.children
                    }
                }
                return {
                    id: node.id,
                    label: node.name,
                    children: undefined
                }
            },
            /*-----------------------------------*/
        },
    }
</script>
